import type { AuthAccountWithPassType } from './api-client/accounts';
import type { OTTransaction } from 'bc-ot';
import type { OTFailure } from './stores/sync/types';

interface ArtifactClient {
  getAmendStateComment: (briefId: number) => string | undefined;
  getTransactionAuthor: () => AuthAccountWithPassType | null;

  onCrossPlanUpdateFailure: () => void;

  onOTSuccess?: (transaction: OTTransaction) => void;
  onOTFailure?: (info: OTFailure, retry: () => void, abort: () => void) => void;
  onRateLimited?: (retryAfterMs: number) => void;
  getDefaultRetryAfterMs?: () => number | undefined;
}

const NOOP = () => {};

const THROW_UNIMPLEMENTED = (): never => {
  throw new Error('Client has not been initialized. Please call initializeClient at entrypoint.');
};

class Client implements ArtifactClient {
  init(c: ArtifactClient) {
    Object.assign(this, c);
  }

  // Stub implementation
  appState = {
    loaded: false,
  };

  getAmendStateComment: ArtifactClient['getAmendStateComment'] = THROW_UNIMPLEMENTED;

  getTransactionAuthor: ArtifactClient['getTransactionAuthor'] = THROW_UNIMPLEMENTED;

  onCrossPlanUpdateFailure: ArtifactClient['onCrossPlanUpdateFailure'] = NOOP;

  onOTSuccess: ArtifactClient['onOTSuccess'] = NOOP;

  onOTFailure: ArtifactClient['onOTFailure'] = NOOP;

  onRateLimited: ArtifactClient['onRateLimited'] = NOOP;

  getDefaultRetryAfterMs: ArtifactClient['getDefaultRetryAfterMs'] = () => undefined;
}

const client = new Client();

type ArtifactClientOptions = ArtifactClient;

const setupArtifactClient = (opts: ArtifactClientOptions): ArtifactClient => {
  client.init(opts);
  return client;
};

export type { ArtifactClient, ArtifactClientOptions };
export { setupArtifactClient };
export default client;
